import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { PolicyModalSectionProps } from '../PolicyModalStore';
import FlagStore from '../../FlagStore';

const DEFAULT_VALUES = {
    includeRecentlyScanned: true,
};

export default class RedirectRulesOptionsStore {
    static PropType = PropTypes.shape({
        includeRecentlyScanned: FlagStore.PropType.isRequired,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class RedirectRulesOptionsStore */{
            includeRecentlyScanned: new FlagStore(),

            originalValue: {},
        }, data);
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        this.originalValue = value;
        this.includeRecentlyScanned.setValue(value.includeRecentlyScanned);
    });

    getValue = () => ({
        includeRecentlyScanned: this.includeRecentlyScanned.value,
    });

    hasChanged = () => !this.includeRecentlyScanned.equals(this.originalValue.includeRecentlyScanned);
}
